export default __webpack_public_path__ + "static/q_viking-026b4097aa03f7419cc4f282b598eb83.png";